import makeStyles from "utils/makeStyles";

const styles = makeStyles((theme) => ({
  root: {
    // backgroundColor: '#e2dada',
  },
}));

export default styles;
